<template lang="html">
  <boxwrap class="marquee-inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <!-- <search
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search> -->
        <button
          class="btn--create"
          title="create"
          @click="showCreate = true"
        >
          <i class="ico--create"></i>
        </button>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading}">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>
      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
        v-else
      >
        <tbl-inner >
          <tbl-head>
            <tbl-row>
              <tbl-td
                name="mark"
              >

              </tbl-td>

              <tbl-td
                name="created_at"
              >
                created at
              </tbl-td>

              <tbl-td
                name="content"
              >
                content
              </tbl-td>

              <tbl-td
                name="updated_at"
              >
                updated at
              </tbl-td>

              <tbl-td
                name="deleted_at"
              >
                deleted at
              </tbl-td>

              <tbl-td
                name="actions"
              >

              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="mark in marquees"
              :key="mark.id"
              @click.native="showModifyPopUp(mark)"
            >
              <tbl-td
                name="mark"
              >
                <button
                  class="btn--bookmark"
                  :class="{'-main': mark.is_show }"
                  @click.stop
                  @click="setShow(mark, { is_show: !mark.is_show })"
                >
                  <i class="ico--bookmark"></i>
                </button>
              </tbl-td>

              <tbl-td
                name="created_at"
              >
                {{mark.created_at | date }}
              </tbl-td>
              
              <tbl-td
                name="content"
                v-html
              >
                <span v-html="mark.marquee"></span>
              </tbl-td>

              <tbl-td
                name="updated_at"
              >
                {{mark.updated_at | date }}
              </tbl-td>

              <tbl-td
                name="deleted_at"
              >
                <span v-if="mark.deleted_at">
                  {{mark.deleted_at | date }}
                </span>
                <span  v-else>-</span>
              </tbl-td>
              <tbl-td
                name="deleted_at"
                @click.stop
              >
                <button class="btn--delete" @click="del(mark.id)" @click.stop>
                  <i class="ico--delete"></i>
                </button>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>
      </tbl>
    </boxwrap-contents>

    <modal
      class="modal--create-marquee"
      title="create marquee"
      v-if="showCreate"
      :activate="showCreate"
      @activate="event => { showCreate = event, reset() }"
    >
    <template slot="body">
      <div class="form-con">
        <div class="form-items">
          <div class="form-lbl">content</div>
          <div class="textarea-wrap">
            <quill-editor
              ref="textarea"
              v-model="data.text"
              :options="quillConfig"
            ></quill-editor>
          </div>
        </div>
        <div class="form-items">
          <div class="form-lbl">show</div>
          <div class="form-data">
            <checkbox>
              <input
                type="checkbox"
                v-model="data.is_show"
              />
            </checkbox>
          </div>
        </div>
      </div>
    </template>

    <template slot="footer">
      <button
        class="btn--create -withlabel -right"
        @click="save(data)"
      >
        <i class="ico--save"></i>
        <span>create</span>
      </button>
    </template>
    </modal>

    <modal
      class="modal--modify-marquee"
      title="modify marquee"
      v-if="showModify"
      :activate="showModify"
      @activate="event => { showModify = event, reset() }"
    >
    <template slot="body">
      <div class="form-con">
        <div class="form-items">
          <div class="form-lbl"><span>Created at</span></div>
          <div class="form-data">
            <div class="input-wrap">
              <span>{{ data.created_at | date }}</span>
            </div>
          </div>
        </div>
        <div class="form-items">
          <div class="form-lbl"><span>Updated at</span></div>
          <div class="form-data">
            <div class="input-wrap">
              <span>{{ data.updated_at | date }}</span>
            </div>
          </div>
        </div>
        <div class="form-items">
          <div class="form-lbl -content">
            <span>content</span>
          </div>
          <div class="form-data">
            <div class="textarea-wrap">
              <quill-editor
                ref="textarea"
                v-model="data.text"
                :options="quillConfig"
              ></quill-editor>
            </div>
          </div>
        </div>
        <div class="form-items">
          <div class="form-lbl">show</div>
          <div class="form-data">
            <checkbox>
              <input
                type="checkbox"
                v-model="data.is_show"
              />
            </checkbox>
          </div>
        </div>
      </div>
    </template>

    <template slot="footer">
      <button
        class="btn--modify -withlabel -right"
        @click="save(data)"
      >
        <i class="ico--save"></i>
        <span>Modify</span>
      </button>
    </template>
    </modal>
  </boxwrap>
</template>

<script>
import { mapState, mapActions } from 'vuex'
// == components
import Search from '@/components/base/search/Search'
import Modal from '@/components/base/Modal'
import CheckDataList from '@/components/base/CheckDataList'
import Checkbox from '@/components/base/Checkbox'
import { quillEditor } from 'vue-quill-editor'

import { swal } from '@/assets/js/mixins/base/Swal'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  name: 'marquee',

  components: {
    Search,
    Modal,
    CheckDataList,
    Checkbox,
    'quill-editor': quillEditor
  },

  mixins: [ swal ],

  data () {
    return {
      showModify: false,
      showCreate: false,

      quillConfig: {
        placeholder: 'Content here...',
        modules: {
          toolbar: [
            [{ 'align': [] }],
            ['bold', 'italic', 'underline', 'strike'],
            ['image', 'code-block'],
            [
              { 'list': 'ordered' },
              { 'list': 'bullet' }
            ],
            [
              { 'indent': '-1' },
              { 'indent': '+1' }
            ],
            [
              { 'direction': 'rtl' }
            ],
            [
              { 'color': [] },
              { 'background': [] }
            ]
          ]
        }
      },

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      data: this.defaultModel()
    }
  },

  created () {
    this.search()
  },

  computed: {
    ...mapState('settings-marquee', ['marquees'])
  },

  watch: {

  },

  methods: {
    ...mapActions('settings-marquee', ['get', 'create', 'update', 'delete']),

    defaultModel () {
      return {
        text: '',
        is_show: false
      }
    },

    showModifyPopUp (data) {
      this.showModify = true
      this.data = data
      this.data.text = data.marquee

      console.log(this.data)
    },

    reset () {
      this.data = this.defaultModel()
    },

    async search () {
      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.get()

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.marquees.length) {
        this.isEmpty = true
      }
    },

    async save (data) {
      let alertTitle = !data.id ? 'Create Marquee' : 'Modify Marquee'

      let success = async () => {
        if (!data.id) {
          await this.create(data)
          this.showCreate = false
        } else {
          data.marquee = data.text
          await this.update({ id: data.id, data })
          this.showModify = false
        }
        this.reset()
        this.search()
      }

      if (data.text === '') {
        this.$alert('error', 'All fields required.', {}, '', 'Error')
        return
      }

      if (data.text.replace(/(<([^>]+)>)/ig, ' ').trim() === '') {
        this.$alert('error', 'All fields required.', {}, '', 'Error')
        return
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, alertTitle)
    },

    async setShow (item, data) {
      let success = async () => {
        data.marquee = item.marquee
        await this.update({ id: item.id, data })
        this.search()
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, 'Show Marquee')
    },

    async del (id) {
      let success = async () => {
        await this.delete(id)
        this.search()
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, 'Delete ?')
    }
  }
}
</script>

<style lang="css" scoped>
</style>
